import React, { useEffect } from 'react';
import { DrawerCustomClean } from '../drawer/DrawerCustomClean';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline';
import { MenuItem } from './MenuItem';
import { onlyInvoice, onlyRequests, userMenu } from '../../static/data';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../redux/actions/user';
import { getTotalRequestInvoicePending, getTotalRequestStudentsPending } from '../../redux/actions/analytics';

export const DrawerMenu = ({
    isOpenDrawerMenu,
    toggleDrawerFilters,
}) => {

    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { firstName, secondName, lastName, secondSurname, typeUser } = user;

    useEffect(() => {
        onlyRequests.includes(typeUser) &&
            dispatch(getTotalRequestStudentsPending('pending'));
    }, [dispatch, typeUser]);
    
    useEffect(() => {
        onlyInvoice.includes(typeUser) &&
            dispatch(getTotalRequestInvoicePending('pending'));
    }, [dispatch, typeUser]);

    const handleLogOut = () => {
        dispatch(logoutUser())
    }

    return (
        <DrawerCustomClean
            isOpen={isOpenDrawerMenu}
            toggleDrawer={toggleDrawerFilters}
            direction='right'
        >

            <section className="flex flex-col h-full">
                {/* Header */}
                <header className='w-full flex flex-col mt-2 bg-slate-100 h-[100px] rounded-lg items-start
                     justify-center mb-10 shadow-inner py-4 px-8'>
                    <span className='text-gray-900 text-[20px] font-semibold capitalize'>{`${firstName} ${secondName ? secondName : ''} ${lastName} ${secondSurname ? secondSurname : ''}`}</span>
                    <span className='text-indigo-600 font-semibold capitalize'>{typeUser}</span>
                </header>
                {/* Content */}
                <main className="flex-1 py-4 px-4 overflow-auto">
                    {userMenu.map((item) => (
                        item.access.includes(user.typeUser) && (
                            (user.roles === 'user' && item.name === 'Configuracion')
                                ? null
                                : (
                                    <MenuItem
                                        toggleDrawerFilters={toggleDrawerFilters}
                                        key={item.name}
                                        name={item.name}
                                        description={item.description}
                                        href={item.href}
                                        icon={item.icon}
                                    />
                                )
                        )
                    ))}
                </main>
                {/* Footer */}
                <footer className="w-[100] border-t p-2 mb-2 border-gray-200">
                    <div
                        onClick={() => handleLogOut()}
                        className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-100 mt-5"
                    >
                        <div
                            className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                        >
                            <ArrowRightStartOnRectangleIcon
                                aria-hidden="true"
                                className="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                            />
                        </div>
                        <div className="flex items-center">
                            <span className="font-semibold text">
                                Cerrar Sesión
                            </span>
                        </div>

                    </div>
                </footer>
            </section>
        </DrawerCustomClean>
    )
}
